import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  container: {
    maxHeight: 440,
  },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

export default function CouplesByPriceTable({ data }) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table stickyHeader className={classes.table} aria-label="simple table">
        <TableHead>
          <StyledTableRow>
            <StyledTableCell>Bride</StyledTableCell>
            <StyledTableCell>Groom</StyledTableCell>
            <StyledTableCell>Wedding Date</StyledTableCell>
            <StyledTableCell>Booked Date</StyledTableCell>
            <StyledTableCell>Venue</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell>Province</StyledTableCell>
            <StyledTableCell>Fee</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {data.weddingList.map((row) => (
            <StyledTableRow key={`wedding-${row.id}`}>
              <StyledTableCell component="th" scope="row">
                <a href={`/admin/couples/${row.id}`} target="_blank">{row.bride_full_name}</a>
              </StyledTableCell>
              <StyledTableCell>{row.groom_full_name}</StyledTableCell>
              <StyledTableCell>{row.wedding_date_formatted}</StyledTableCell>
              <StyledTableCell>{row.date_booked_formatted}</StyledTableCell>
              <StyledTableCell>{row.venue}</StyledTableCell>
              <StyledTableCell>{row.status}</StyledTableCell>
              <StyledTableCell>{row.province}</StyledTableCell>
              <StyledTableCell>{row.fee}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
